<template>
  <vinnuskoli-page>
    <b-row class="mb-3">
      <b-col>
        <div class="page-title mb-0">Uppgjör</div>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <b-btn
          variant="primary"
          class="pull-right"
          v-if="options.batch.selectedBatch && options.batch.selectedBatch.status === 'NEW'"
          @click.prevent="populateBatchModal"
        >
          <i class="fa fa-fw fa-check-circle"></i>
          Staðfesta forskoðun
        </b-btn>
        <b-btn variant="secondary" class="pull-right mr-3" @click.prevent="previewBatchModal">
          <i class="fa fa-fw fa-plus-circle"></i>
          Stofna uppgjör
        </b-btn>
      </b-col>
    </b-row>
    <div v-if="!batchList || batchList.length === 0">
      <i>Ekkert uppgjör fannst. Vinsamlegast keyrið uppgjör hérna hægra megin.</i>
    </div>
    <div v-else>
      <b-row>
        <b-col>
          <b-form-select id="batch" name="batch" v-model="options.batch.selectedBatch" @input="onBatchChange">
            <option v-for="batch in batchList" :key="batch.id" :value="batch">
              {{ batch.payment_period.name }}
              ({{ batch.payment_period.date_from | moment('DD.MM.YYYY') }} - {{ batch.payment_period.date_to | moment('DD.MM.YYYY') }})
              <template v-if="batch.is_extra"> - Auka uppgjör {{ batch.extra_number }}</template>
            </option>
          </b-form-select>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <h5 class="page-title" style="font-size: 20px">
            <span v-if="options.batch.selectedBatch && options.batch.selectedBatch.status === 'NEW'">Forskoðun</span>
            <span v-if="options.batch.selectedBatch && options.batch.selectedBatch.status === 'POPULATED'">
              Staðfestar færslur
              <i class="fa fa-fw fa-file-excel-o" @click.prevent="getExcel" style="cursor: pointer; color: #008000"></i>
              <b-btn @click.prevent="getH3" class="pull-right btn-sm btn-dark" style="margin-left: 10px">
                <i class="fa fa-fw fa-file-o"></i>
                Sækja skrá fyrir launakerfi
              </b-btn>
              <b-btn
                @click.prevent="submitToKjarni"
                class="pull-right btn-sm btn-dark"
                style="margin-left: 10px"
                v-if="loggedInUser.town.hasKjarni"
                :disabled="submittingToKjarni || options.batch.selectedBatch.date_sent_to_kjarni || submittedToKjarni"
              >
                <i v-if="!submittingToKjarni" class="fa fa-fw fa-paper-plane mr-1"></i>
                <i v-if="submittingToKjarni" class="fa fa-fw fa-spinner fa-spin mr-1" />
                <template v-if="!submittedToKjarni && !options.batch.selectedBatch.date_sent_to_kjarni">Lesa inn í Kjarna</template>
                <template v-if="submittedToKjarni || options.batch.selectedBatch.date_sent_to_kjarni">Sent í Kjarna</template>
                <template v-if="!submittedToKjarni && options.batch.selectedBatch.date_sent_to_kjarni">
                  {{ options.batch.selectedBatch.date_sent_to_kjarni | moment('DD.MM.YYYY hh:mm:ss') }}</template
                >
              </b-btn>
            </span>
          </h5>
          <div class="alert alert-danger" v-if="errorList.length > 0">
            <div style="display: inline-block">
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            </div>
            <div style="display: inline-block">
              <div v-for="(err, idx) in errorList" :key="idx">{{ err }}</div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-2" v-if="errorList.length === 0 && this.options.batch.selectedBatch">
        <b-col cols="3">
          <strong>Nafn</strong>
          <b-form-input id="name" name="name" type="text" v-model="filter.name" placeholder="Sía eftir nafni"></b-form-input>
        </b-col>
        <b-col cols="3">
          <strong>Kennitala</strong>
          <b-form-input id="ssn" name="name" type="text" v-model="filter.ssn" placeholder="Sía eftir kennitölu"></b-form-input>
        </b-col>
        <b-col cols="3" v-if="periodPartList.length > 0">
          <strong>Starfstímabil</strong>
          <b-form-select id="part" name="part" v-model="filter.part">
            <option :value="null">-- Sía eftir starfstímabili --</option>
            <option v-for="part in periodPartList" :key="part.id" :value="part.id">
              {{ part.date_from | moment('DD.MM.YYYY') }} - {{ part.date_to | moment('DD.MM.YYYY') }}
            </option>
          </b-form-select>
        </b-col>
        <b-col cols="3" v-if="workplaceList.length > 0">
          <strong>Starfsstaður</strong>
          <b-form-select id="workplace" name="workplace" v-model="filter.workplace">
            <option :value="null">-- Sía eftir starfsstað --</option>
            <option v-for="workplace in sortWorkplaceList" :key="workplace.id" :value="workplace.id">{{ workplace.name }}</option>
          </b-form-select>
        </b-col>
      </b-row>
      <pagination
        v-if="pagination"
        :pagination-response="pagination"
        @change-limit="changeLimitWithPersistence"
        @change-page="changePageWithPersistence"
      />
      <b-card no-body border-variant="light" class="mb-2">
        <div class="m-2" v-if="loading.batches || loading.records"><loading /></div>
        <div
          class="m-2"
          v-if="
            !loading.batches && !loading.records && recordList.length === 0 && errorList.length === 0 && this.options.batch.selectedBatch
          "
        >
          <i>Engar færslur fundust</i>
        </div>
        <div v-if="!loading.batches && !loading.records && recordList.length > 0">
          <table class="table mb-0">
            <thead>
              <tr class="bg-gray-200 small">
                <th @click.prevent="changeSort('name')" style="cursor: pointer">Nafn</th>
                <th @click.prevent="changeSort('ssn')" style="cursor: pointer">Kennitala</th>
                <th @click.prevent="changeSort('placement_group.period.name')" style="cursor: pointer">Tímabil</th>
                <th @click.prevent="changeSort('placement_group.workplace.name')" style="cursor: pointer">Hópur</th>
                <th @click.prevent="changeSort('birth_year')" style="cursor: pointer">Fæðingarár</th>
                <th @click.prevent="changeSort('days')" style="cursor: pointer" class="text-center">
                  Dagar/Tímabils
                  <i
                    class="fa fa-fw fa-info-circle"
                    v-b-tooltip.hover
                    title="Fjöldi daga sem þátttakandi er að fá borgaða / Fjöldi daga innan tímabils miðað við skráningu hóps"
                  ></i>
                </th>
                <th class="text-center" @click.prevent="changeSort('hours')" style="cursor: pointer">
                  Klst/Hámark
                  <i
                    class="fa fa-fw fa-info-circle"
                    v-b-tooltip.hover
                    title="Fjöldi klst sem þátttakandi er að fá borgaða / Hámarksfjöldi klukkutíma sem hægt er að skrá. Veikindaklst eru sýndar sérstaklega undir og eru innifaldar í heildarlaunum."
                  ></i>
                </th>
                <th class="text-right" @click.prevent="changeSort('wages_corrections')" style="cursor: pointer">
                  Leiðrétting
                  <i
                    class="fa fa-fw fa-info-circle"
                    v-b-tooltip.hover
                    title="Fjöldi klst sem leiðrétting nær yfir / Upphæð sem leiðrétting nær yfir"
                  ></i>
                </th>
                <th class="text-right" @click.prevent="changeSort('wage_age')" style="cursor: pointer">Tímakaup</th>
                <th class="text-right" @click.prevent="changeSort('wages')" style="cursor: pointer">Heildarlaun</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(record, index) in recordList" :key="index">
                <td>
                  {{ record.name }}
                  <span v-if="options.batch.selectedBatch && options.batch.selectedBatch.status === 'POPULATED'">
                    <b-link
                      :to="{
                        name: 'StudentWithGroup',
                        params: { id: record.person_id, group: record.placement_group_id },
                      }"
                      target="_blank"
                    >
                      <i class="fa fa-fw fa-search" v-b-tooltip.hover title="Skoða þátttakanda"></i>
                    </b-link>
                  </span>
                  <span v-else>
                    <b-link
                      :to="{
                        name: 'StudentWithGroup',
                        params: { id: record.id, group: record.placement_group.id },
                      }"
                      target="_blank"
                    >
                      <i class="fa fa-fw fa-search" v-b-tooltip.hover title="Skoða þátttakanda"></i>
                    </b-link>
                  </span>
                </td>
                <td>{{ record.ssn }}</td>
                <td>
                  <span v-if="options.batch.selectedBatch && options.batch.selectedBatch.status === 'POPULATED'">
                    {{ record.period_name }}
                    <div v-if="record.period_part_date_from" style="display: block; font-style: italic; font-size: 10px">
                      {{ record.period_part_date_from | moment('DD.MM.YYYY') }} - {{ record.period_part_date_to | moment('DD.MM.YYYY') }}
                    </div>
                  </span>
                  <span v-else>
                    {{ record.placement_group.period.name }}
                    <div v-if="record.placement_group.period_part" style="display: block; font-style: italic; font-size: 10px">
                      {{ record.placement_group.period_part.date_from | moment('DD.MM.YYYY') }}
                      - {{ record.placement_group.period_part.date_to | moment('DD.MM.YYYY') }}
                    </div>
                  </span>
                </td>
                <td>
                  <span v-if="options.batch.selectedBatch && options.batch.selectedBatch.status === 'POPULATED'">
                    {{ record.workplace_name }} - {{ record.placement_group_name }}
                    <b-link
                      :to="{
                        name: 'Group',
                        params: { id: record.placement_group_id },
                      }"
                      target="_blank"
                    >
                      <i class="fa fa-fw fa-search" v-b-tooltip.hover title="Skoða hóp"></i>
                    </b-link>
                    <br />
                    <small style="display: block; font-style: italic; font-size: 10px"
                      >{{ record.placement_group_date_from | moment('DD.MM.YYYY') }} -
                      {{ record.placement_group_date_to | moment('DD.MM.YYYY') }}</small
                    >
                  </span>
                  <span v-else>
                    {{ record.placement_group.workplace.name }} - {{ record.placement_group.name }}
                    <b-link
                      :to="{
                        name: 'Group',
                        params: { id: record.placement_group.id },
                      }"
                      target="_blank"
                    >
                      <i class="fa fa-fw fa-search" v-b-tooltip.hover title="Skoða hóp"></i>
                    </b-link>
                    <br />
                    <small style="display: block; font-style: italic; font-size: 10px"
                      >{{ record.placement_group.date_from | moment('DD.MM.YYYY') }} -
                      {{ record.placement_group.date_to | moment('DD.MM.YYYY') }}</small
                    >
                  </span>
                </td>
                <td>
                  {{ record.birth_year }}
                  <strong v-if="record.birth_year_overridden">
                    ({{ record.birth_year_real }})
                    <i
                      class="fa fa-fw fa-info-circle"
                      v-b-tooltip.hover
                      :title="`Þessi þátttakandi er með undanþágu og á að vera tekið sem ${record.birth_year}`"
                    ></i>
                  </strong>
                </td>
                <td class="text-center">{{ record.days }}/{{ record.days_in_period }}</td>
                <td class="text-center">
                  <span
                    >{{ record.hours | formatMaxHours
                    }}<span v-if="record.max_hours_in_period">/{{ record.max_hours_in_period | formatMaxHours }}</span></span
                  >
                  <b-link
                    :to="{
                      name: 'AttendanceWithParams',
                      params: {
                        date: record.placement_group ? record.placement_group.date_from : record.placement_group_date_from,
                        group: record.placement_group ? record.placement_group.id : record.placement_group_id,
                      },
                    }"
                    target="_blank"
                    class="ml-1"
                  >
                    <i class="fa fa-fw fa-search" v-b-tooltip.hover title="Skoða viðveru"></i>
                  </b-link>
                  <span v-if="record.sick_hours > 0" class="d-block text-muted">+ {{ record.sick_hours | formatMaxHours }} veikindi</span>
                </td>
                <td class="text-right">
                  <span>{{ record.hours_corrections }} / {{ record.wages_corrections | currency }}</span>
                </td>
                <td class="text-right">{{ record.wage_age | currency }}</td>
                <td class="text-right">{{ (Number(record.wages) + Number(record.sick_wages)) | currency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
      <pagination
        v-if="pagination"
        :pagination-response="pagination"
        @change-limit="changeLimitWithPersistence"
        @change-page="changePageWithPersistence"
      >
      </pagination>
    </div>
    <preview-batch-modal ref="previewBatchModal" @successful="batchCreated"></preview-batch-modal>
    <populate-batch-modal ref="populateBatchModal" @successful="batchPopulated"></populate-batch-modal>
  </vinnuskoli-page>
</template>

<script>
// import moment from 'moment';
import { mapActions, mapGetters, mapState } from 'vuex';
import payment from '@/api/payment';
import { djangoErrorsToVee, paginationMixin, paginationPersistenceMixin, parsePagination, debounce } from '@/utils';
import PreviewBatchModal from '@/components/batch/previewBatchModal.vue';
import PopulateBatchModal from '@/components/batch/populateBatchModal.vue';
import Pagination from '@/components/Pagination.vue';
import core from '@/api/core';

export default {
  name: 'batch',
  components: {
    PreviewBatchModal,
    PopulateBatchModal,
    Pagination,
  },
  mixins: [paginationMixin, paginationPersistenceMixin],
  data() {
    return {
      // Set the pagination key
      paginationKey: 'batchView',
      loading: {
        batches: false,
        records: false,
      },
      sort: 'name',
      sortdesc: false,
      errorList: [],
      batchList: [],
      batch: null,
      recordList: [],
      options: {},
      filter: {
        part: null,
        workplace: null,
        ssn: '',
        name: '',
      },
      periodPartList: [],
      workplaceList: [],
      submittingToKjarni: false,
      submittedToKjarni: false,
      pagination: null,
      debouncedLoadData: null,
    };
  },
  computed: {
    sortWorkplaceList() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.workplaceList.sort((a, b) => (a.name > b.name ? 1 : -1));
    },
    ...mapGetters(['loggedInUserOptions']),
    ...mapState({
      loggedInUser: 'loggedInUser',
    }),
  },
  methods: {
    async load(id) {
      this.loading.batches = true;
      this.batchList = [];
      try {
        const response = await payment.paymentBatchList();
        this.batchList = response.data;
        if (id) {
          this.options.batch.selectedBatch = this.batchList.find(x => x.id === id);
          this.loadData();
        } else if (this.options.batch.selectedBatch) {
          this.loadData();
        }
      } catch (e) {
        this.$log.error(e);
        if (e.response && e.response.status === 400) {
          djangoErrorsToVee(e.response.data, this.errors, this.errorList);
        } else {
          this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
        }
      } finally {
        this.loading.batches = false;
      }
    },
    onBatchChange() {
      // Reset filters when batch changes
      this.filter = {
        part: null,
        workplace: null,
        ssn: '',
        name: '',
      };
      // Reset to first page when batch changes
      this.currentPage = 1;
      this.savePaginationOptions();
      this.loadData();
    },
    async loadWorkplace() {
      this.workplaceList = [];
      try {
        const response = await core.dropdownWorkplaceList();
        this.workplaceList = response.data;
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      }
    },
    async loadPeriodParts() {
      try {
        const periodDropdownResponse = await this.$coreApi.periodDropdownList();

        if (periodDropdownResponse.data.length > 0) {
          // fetch the first period (current)
          const periodId = periodDropdownResponse.data[0].id;
          const periodPartsResponse = await this.$coreApi.periodDropdownPeriodPartDropdownList({
            period: periodId,
          });

          periodPartsResponse.data.forEach(part => {
            const tmpPart = {
              id: part.id,
              date_from: part.dateFrom,
              date_to: part.dateTo,
            };
            this.periodPartList.push(tmpPart);
          });
        }
      } catch (e) {
        // error handling
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      }
    },
    async loadData(page, limit) {
      // Use current pagination state if not provided
      const actualPage = page || this.currentPage;
      const actualLimit = limit || this.currentLimit;

      this.recordList = [];
      this.errorList = [];
      // Only reset filter lists when no batch is selected
      if (!this.options.batch.selectedBatch) {
        this.filter.part = null;
        this.filter.workplace = null;
      }
      this.loading.records = true;
      try {
        let response = null;
        if (this.options.batch.selectedBatch && this.options.batch.selectedBatch.status === 'NEW') {
          response = await payment.paymentBatchPreview(
            this.options.batch.selectedBatch.id,
            this.sort,
            this.sortdesc,
            actualPage,
            actualLimit,
            this.filter.name,
            this.filter.ssn,
            this.filter.part,
            this.filter.workplace,
          );
          this.recordList = response.data;
        } else {
          response = await payment.paymentBatchLineList(
            null,
            this.options.batch.selectedBatch.id,
            null,
            null,
            this.sort,
            this.sortdesc,
            actualPage,
            actualLimit,
            this.filter.name,
            this.filter.ssn,
            this.filter.part,
            this.filter.workplace,
          );
          this.recordList = response.data;
        }

        this.pagination = parsePagination(response);

        // Save pagination options after successful load
        this.savePaginationOptions();

        await this.setLoggedInUserOption({ option: 'batch', value: this.options.batch });
        await this.saveLoggedInUserOptions();
      } catch (e) {
        this.$log.error(e);
        if (e.response && e.response.status === 400) {
          djangoErrorsToVee(e.response.data, this.errors, this.errorList);
        } else {
          this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
        }
      } finally {
        this.loading.records = false;
      }
    },
    // Alias for backward compatibility
    loadRecords(page, limit) {
      this.loadData(page, limit);
    },
    batchCreated(data) {
      if (data.id) {
        this.load(data.id);
      }
    },
    batchPopulated() {
      this.load(this.options.batch.selectedBatch.id);
    },
    changeSort(column) {
      if (this.sort === column) {
        this.sortdesc = !this.sortdesc;
      } else {
        this.sort = column;
        this.sortdesc = false;
      }
      // Reset to first page when sorting changes
      this.currentPage = 1;
      this.savePaginationOptions();
      this.loadData();
    },
    async getExcel() {
      const w = window.open('', '_blank');

      const response = await payment.paymentBatchExcelToken(this.options.batch.selectedBatch.id);
      w.location.href = response.data.url;
    },
    async getH3() {
      const w = window.open('', '_blank');

      const response = await payment.paymentBatchH3Token(this.options.batch.selectedBatch.id);
      w.location.href = response.data.url;
    },
    async submitToKjarni() {
      this.submittingToKjarni = true;
      this.submittedToKjarni = false;

      try {
        await this.$paymentApi.submitToKjarni({ batch: this.options.batch.selectedBatch.id });

        this.displaySuccess(`Innlestri lokið.`);
        this.submittedToKjarni = true;
      } catch (e) {
        if ('response' in e) {
          this.displayError(JSON.parse(e.response.data));
        } else {
          this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
        }
      } finally {
        this.submittingToKjarni = false;
      }
    },
    changeLimit(limit) {
      this.currentPage = 1; // Reset to first page when limit changes
      this.currentLimit = limit;
      this.savePaginationOptions();
      this.loadRecords(1, limit);
    },
    changePage(page) {
      this.currentPage = page;
      this.savePaginationOptions();
      this.loadRecords(page, this.currentLimit);
    },
    /*
     * Modal gluggar
     */
    previewBatchModal() {
      this.$refs.previewBatchModal.show();
    },
    populateBatchModal() {
      this.$refs.populateBatchModal.show(this.options.batch.selectedBatch.id);
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
      saveLoggedInUserOptions: 'saveLoggedInUserOptions',
      setLoggedInUserOption: 'setLoggedInUserOption',
    }),
  },
  watch: {
    'filter.name': function () {
      this.currentPage = 1;
      this.savePaginationOptions();
      this.debouncedLoadData();
    },
    'filter.ssn': function () {
      this.currentPage = 1;
      this.savePaginationOptions();
      this.debouncedLoadData();
    },
    'filter.part': function () {
      this.currentPage = 1;
      this.savePaginationOptions();
      this.loadData();
    },
    'filter.workplace': function () {
      this.currentPage = 1;
      this.savePaginationOptions();
      this.loadData();
    },
  },
  created() {
    // Load pagination options before initializing
    this.loadPaginationOptions();

    this.loadWorkplace();
    this.loadPeriodParts();

    // Initialize debounced function
    this.debouncedLoadData = debounce(() => {
      this.loadData();
    }, 500);

    this.load(this.$route.query.id);
    this.options = {};

    this.options.batch = {
      selectedBatch: null,
      ...this.loggedInUserOptions.batch,
    };
  },
};
</script>

<style></style>
